import { Tab, Tabs } from "pages/private/Receivement/style";

import { Paper } from "./style";

const defaultTabs = [
  { label: "A receber", value: 0 },
  { label: "Finalizado", value: 1 }
];

export const TabReceipt = ({
  activeTab,
  handleChangeTable,
  tabs = defaultTabs
}) => (
  <Paper square>
    <Tabs
      value={activeTab}
      indicatorColor="primary"
      textColor="primary"
      onChange={handleChangeTable}
      variant="fullWidth"
      style={{ marginBottom: "2rem" }}
    >
      {tabs.map(tab => (
        <Tab key={tab.value} label={tab.label} value={tab.value} />
      ))}
    </Tabs>
  </Paper>
);
